import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export function useLoadingIndicatorStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      loadingIndicator: {
        backgroundColor: semanticColors.disabledBackground,
        opacity: 0.6,
        display: `flex`,
        position: `absolute`,
        margin: `auto`,
        width: `100vw`,
        height: `100vh`,
        right: 0,
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 1000002
      }
    }),
    [semanticColors]
  );
}
